@switch(this.srvAppMode.mode$ | async) {
  @case (AppMode.WEB) {
    <ng-container *ngTemplateOutlet="WEB_MODE_FOOTER"></ng-container>
  }
  @case (AppMode.DEMO) {
    @if (this.srvAppMode.isDemoUrl$() | async) {
      <ng-container *ngTemplateOutlet="DEMO_MODE_FOOTER"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="WEB_MODE_FOOTER"></ng-container>
    }
  }
}

<ng-template #WEB_MODE_FOOTER>
  @if (externalLoaded && this.SkinService.isSkin_1()) {
    <footer class="footer">
      @if (!(loggedIn | async)) {
        <div class="back-color-me" [ngStyle]="UIUtilityService.getBankButtonStyle(this.externalSettings)">
          <div class="container">
            <div class="row text-white">
              <div class="col-12 col-sm-6 pt-2 pb-2">
                <p class="mb-0 line-height-1rem mr-2">
                  <small class="font-footer-strip-title">Mobile Banking Login</small>
                </p>
                <p class="mb-0 line-height-1rem mr-2">
                  <small class="font-footer-strip-subtitle">{{ disclaimerLogin }}</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      } @else {
        <div class="back-color-me">
          <div class="container">
            <div class="row text-white">
              <div class="col-12 py-2">
                <mat-divider></mat-divider>
              </div>
            </div>
          </div>
        </div>
      }
  
      <div class="back-white">
        <div class="container">
          <div class="row">
            <div class="col-12 col-sm-6 font14 pt-2 pb-2 address-contacts">
              <app-address-contacts></app-address-contacts>
            </div>
            <div class="col-12 col-sm-6 pt-2 pb-3 secure-icons">
              <app-secure-icons></app-secure-icons>
            </div>
          </div>
        </div>
      </div>
    </footer>
  }

  @if (!(loggedIn | async) && showFooter && externalLoaded && (this.SkinService.isSkin_2() || this.SkinService.isSkin_3() || this.SkinService.isSkin_4())) {
    <div [ngStyle]="UIUtilityService.getBankButtonStyle(this.externalSettings)">
      <footer class="parent">
        <div class="">
          <app-secure-icons></app-secure-icons>
        </div>
      </footer>
    </div>
  }

  @if ((loggedIn | async) && externalLoaded && (this.SkinService.isSkin_2() || this.SkinService.isSkin_3() || this.SkinService.isSkin_4())) {
    <footer class="parent">
      <div class="container">
        <div class="row text-white">
          <div class="col-12 py-2">
            <mat-divider></mat-divider>
          </div>
        </div>
      </div>
      <div class="back-white">
        <div class="container">
          <div class="row">
            <div class="col-12 col-sm-6 font14 pt-2 pb-2 address-contacts">
              <app-address-contacts></app-address-contacts>
            </div>
            <div class="col-12 col-sm-6 pt-2 pb-3 secure-icons">
              <app-secure-icons></app-secure-icons>
            </div>
          </div>
        </div>
      </div>
    </footer>
  }

</ng-template>

<ng-template #DEMO_MODE_FOOTER>
  <footer class="parent">
    <div class="container child">
      <div class="">
        <app-secure-icons></app-secure-icons>
      </div>
    </div>
  </footer>
</ng-template>